/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * SwitchSystemIcon - Auto-generated from icon.js
 */
export const SwitchSystemIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M14.6 25.4H11V29H14.6V25.4Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M21.8002 25.4H18.2002V29H21.8002V25.4Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M29.0004 25.4H25.4004V29H29.0004V25.4Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M14.6 18.2H11V21.8H14.6V18.2Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M21.8002 18.2H18.2002V21.8H21.8002V18.2Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M29.0004 18.2H25.4004V21.8H29.0004V18.2Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M14.6 11H11V14.6H14.6V11Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M21.8002 11H18.2002V14.6H21.8002V11Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
		<path d="M29.0004 11H25.4004V14.6H29.0004V11Z" fill="#333333" stroke="#333333" strokeLinejoin="round" />
	</svg>
);

export default SwitchSystemIcon;
